<template>
    <v-container fluid class="pa-6">
        <div class="d-flex flex-wrap align-center justify-space-between ga-3 mb-4">
            <div>
                <h2 class="text-h6">Fasce di importo</h2>
                <div class="text-body-2 text-medium-emphasis">Come si distribuiscono i preventivi per valore (IVA esclusa)</div>
            </div>
            <filtro-periodo />
        </div>

        <v-row v-if="kpi">
            <v-col cols="12" sm="6" md="4">
                <v-card variant="outlined">
                    <v-card-text>
                        <div class="text-body-2 text-medium-emphasis">Valore mediano</div>
                        <div class="text-h5 font-weight-bold my-1">{{ formatEuro(kpi.valoreMediano) }}</div>
                        <div class="text-caption text-medium-emphasis">metà dei preventivi è sotto questo valore</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-card variant="outlined">
                    <v-card-text>
                        <div class="text-body-2 text-medium-emphasis">Valore medio</div>
                        <div class="text-h5 font-weight-bold my-1">{{ formatEuro(kpi.valoreMedio) }}</div>
                        <div class="text-caption text-medium-emphasis">
                            alzato dai preventivi più grandi se supera la mediana
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card variant="outlined" class="mt-4" :loading="caricamento">
            <v-card-title>Preventivi e valore per fascia</v-card-title>
            <v-card-subtitle>Quota % sul totale del periodo</v-card-subtitle>
            <v-card-text>
                <div v-if="fasce.length" style="height: 320px">
                    <Bar :data="datiGrafico" :options="opzioniGrafico" />
                </div>
            </v-card-text>
        </v-card>

        <v-card variant="outlined" class="mt-4" :loading="caricamento">
            <v-card-text v-if="fasce.length">
                <v-table density="compact">
                    <thead>
                        <tr>
                            <th>Fascia (€)</th>
                            <th class="text-right">Preventivi</th>
                            <th class="text-right">% preventivi</th>
                            <th class="text-right">Valore</th>
                            <th class="text-right">% valore</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="f in fasce" :key="f.etichetta">
                            <td>{{ f.etichetta }}</td>
                            <td class="text-right">{{ formatNumero(f.n) }}</td>
                            <td class="text-right">{{ formatPerc(f.quotaN) }}</td>
                            <td class="text-right">{{ formatEuro(f.valore) }}</td>
                            <td class="text-right">{{ formatPerc(f.quotaValore) }}</td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { Bar } from "vue-chartjs";
import { COLORI } from "@/utils/chart.js";
import Functions from "@/utils/functions.js";
import periodo from "@/mixins/periodo.js";
import FiltroPeriodo from "@/components/statistiche/FiltroPeriodo.vue";

export default {
    name: "ImportiPage",
    components: { FiltroPeriodo, Bar },
    mixins: [periodo],

    data() {
        return {
            fasce: [],
            kpi: null,
            caricamento: false,
        };
    },

    computed: {
        datiGrafico() {
            return {
                labels: this.fasce.map((f) => f.etichetta),
                datasets: [
                    { label: "% preventivi", data: this.fasce.map((f) => f.quotaN), backgroundColor: COLORI.grigio },
                    { label: "% valore", data: this.fasce.map((f) => f.quotaValore), backgroundColor: COLORI.primary },
                ],
            };
        },

        opzioniGrafico() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: { grid: { display: false } },
                    y: { beginAtZero: true, ticks: { callback: (v) => v + "%" } },
                },
                plugins: {
                    legend: { position: "bottom" },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => ctx.dataset.label + ": " + Functions.formatPerc(ctx.parsed.y),
                        },
                    },
                },
            };
        },
    },

    methods: {
        formatEuro: Functions.formatEuro,
        formatNumero: Functions.formatNumero,
        formatPerc: Functions.formatPerc,

        async carica() {
            this.caricamento = true;
            const periodoRichiesto = this.periodo;
            try {
                const [fasce, kpi] = await Promise.all([
                    this.$store.dispatch("statistiche/fasceImporto"),
                    this.$store.dispatch("statistiche/kpi"),
                ]);
                if (periodoRichiesto === this.periodo) {
                    this.fasce = fasce;
                    this.kpi = kpi.corrente;
                }
            } catch (error) {
                console.log(error);
            }
            this.caricamento = false;
        },
    },
};
</script>
